    import React, { useState, useEffect, useMemo } from "react";
    import classnames from "classnames";
    import { Link } from "react-router-dom";
    import {
    Col, Row, Card, CardBody, Nav, NavItem, NavLink,
    TabContent, TabPane, Badge, Button, UncontrolledTooltip, Input, Spinner,
    Modal, ModalHeader, ModalBody, Table
} from "reactstrap";
    import TableContainer from '../../../components/Common/TableContainer';
    import Breadcrumbs from '../../../components/Common/Breadcrumb';

    const UygunGeziler = () => {
        document.title = "Uygun Geziler | HarmanaGEL";

        const authUser = JSON.parse(localStorage.getItem("authUser"));
    const userId = authUser?.ID;
    const hesapTuru = authUser?.HESAP_TURU || "";

    const isCustomer = hesapTuru === 'Alıcı';
    const isDriver = hesapTuru === 'Satıcı';
    const isAdmin = hesapTuru === 'Admin';

        const [activeTab, setActiveTab] = useState("1");
        
        // Aktif İlanlar (Tüm uygun geziler) State'leri
        const [tripsData, setTripsData] = useState([]);
        const [isLoadingTrips, setIsLoadingTrips] = useState(false);

        // Kullanıcının Teklifleri (Alıntılarım) State'leri
        const [quotesData, setQuotesData] = useState([]);
        const [isLoadingQuotes, setIsLoadingQuotes] = useState(false);

        const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'approved', 'pending'

        // Teklif Modalı State'leri
    const [isOffersModalOpen, setIsOffersModalOpen] = useState(false);
    const [selectedAdvertForOffers, setSelectedAdvertForOffers] = useState(null);

    const toggleOffersModal = () => setIsOffersModalOpen(!isOffersModalOpen);

        const toggleTab = (tab) => {
            if (activeTab !== tab) {
                setActiveTab(tab);
            }
        };

        const filteredTripsData = useMemo(() => {
            return tripsData.filter(trip => {
                // Sadece admin bu filtreyi kullanacağı için, admin değilse tümünü (kendi ilanlarını) göster
                if (!isAdmin) return true; 
                
                if (statusFilter === 'approved') return trip.isAdminCheck === true;
                if (statusFilter === 'pending') return trip.isAdminCheck === false;
                return true; // 'all' durumu
            });
        }, [tripsData, statusFilter, isAdmin]);

        useEffect(() => {
        const fetchAdverts = async () => {
            setIsLoadingTrips(true);
            try {
                // 📌 YENİ: Token'ı alıyoruz
                const token = localStorage.getItem("token") || authUser?.Token;
                
                let filter = "";
                if (isCustomer) {
                    filter = `$filter=KIMDEN_ID eq ${userId}&$top=1000&$orderby=ID desc&`; // KULLANICI_ID yerine KIMDEN_ID olabilir, DB'ye göre kontrol et
                } else if (isDriver) {
                    filter = `$filter=AKTIF_DURUM eq 'aktif'&$top=1000&$orderby=ID desc&`;
                } else if (isAdmin) {
                    filter = `$top=1000&$orderby=ID desc&`;
                }

                // 📌 ÇÖZÜM: KULLANICI_ARACLAR ve ADRESLER kaldırıldı. Sadece teklifler ve KULLANICILAR çekiliyor.
                const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILANLAR?${filter}$expand=KULLANICILAR,ILAN_TEKLIFLERI($expand=KULLANICILAR)`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // 📌 401 Hatasını önler
                    }
                });
                const result = await response.json();

                if (result && result.value) {
                    const formattedData = result.value.map(item => {
                        // 📌 ÇÖZÜM: Olmayan ADRESLER ve Araç tablosu yerine doğrudan ilanın/kullanıcının kendi verisini okuyoruz.
                        const locationCity = item.IL || item.KULLANICILAR?.IL || "Belirtilmedi";
                        const offers = item.ILAN_TEKLIFLERI || [];
                        const myOffer = offers.find(offer => offer.KULLANICI_ID === userId); // Users_ID yerine KULLANICI_ID

                        return {
                            id: item.ID,
                            direction: "Standart", 
                            advertTypeTitle: "Pazaryeri İlanı",
                            
                            startCity: locationCity, 
                            endCity: "Müşteri Adresi", 
                            
                            startDate: item.OLUSTURMA_TARIHI ? new Date(item.OLUSTURMA_TARIHI).toLocaleDateString('tr-TR') : "-",
                            endDate: "-",
                            deadline: "-", 
                            
                            customer: item.KULLANICILAR ? item.KULLANICILAR.AD_SOYAD : "Sistem",
                            
                            carBody: "-", 
                            engine: "-",   
                            brand: "-",
                            model: "-",
                            
                            distance: "-",
                            duration: "-", 
                            fuelStatus: "-",
                            
                            price: item.FIYAT || item.Price || 0,
                            invoiceId: null,
                            invoiceNo: null,
                            invoiceStatus: "Bekliyor",
                            
                            isAdminCheck: item.AKTIF_DURUM, // Is_AdminCheck yerine veritabanındaki karşılığı
                            isActive: item.AKTIF_DURUM,

                            hasOffer: !!myOffer,
                            myOfferPrice: myOffer ? (myOffer.FIYAT || myOffer.Price || myOffer.Own_Offer) : 0,
                            myOfferStatus: myOffer ? (myOffer.DURUM === 1 ? "Kabul Edildi" : myOffer.DURUM === 2 ? "Reddedildi" : "Bekliyor") : "Bekliyor",
                            
                            allOffers: offers
                        };
                    });
                    setTripsData(formattedData);
                }
            } catch (error) {
                console.error("İlanlar çekilirken hata oluştu:", error);
            } finally {
                setIsLoadingTrips(false);
            }
        };

        fetchAdverts();
    }, [isCustomer, isDriver, isAdmin, userId, authUser?.Token]);

    // 2. OData API'den TEKLİFLERİ Çekme İşlemi
useEffect(() => {
        const fetchMyQuotes = async () => {
            if (!userId) return;
            setIsLoadingQuotes(true);
            try {
                const token = localStorage.getItem("token") || authUser?.Token;

                const quoteFilter = isAdmin 
                    ? "$top=1000&$orderby=ID desc" 
                    : `$filter=KULLANICI_ID eq ${userId}&$top=1000&$orderby=ID desc`;
                
                // 📌 ÇÖZÜM: Users yerine KULLANICILAR yazıldı.
                const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILAN_TEKLIFLERI?${quoteFilter}&$expand=KULLANICILAR`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` // 📌 401 Hatasını önler
                    }
                });

                const result = await response.json();

                if (result && result.value) {
                    const formattedQuotes = result.value.map(item => ({
                        offerId: item.ID,
                        advertId: item.ILAN_ID || "-",
                        date: item.TEKLIF_TARIHI ? new Date(item.TEKLIF_TARIHI).toLocaleDateString('tr-TR') : "-",
                        price: item.TEKLIF_TUTARI || 0,
                        status: item.DURUM === 1 ? "Kabul Edildi" : item.DURUM === 2 ? "Reddedildi" : "Bekliyor",
                        // 📌 ÇÖZÜM: item.Users yerine item.KULLANICILAR kullanıldı.
                        driverName: item.KULLANICILAR ? item.KULLANICILAR.AD_SOYAD : "Bilinmiyor"
                    }));
                    setQuotesData(formattedQuotes);
                }
            } catch (error) {
                console.error("Teklifler çekilirken hata:", error);
            } finally {
                setIsLoadingQuotes(false);
            }
        };
        fetchMyQuotes();
    }, [isAdmin, userId, authUser?.Token]);
    
    const durumText = d => d === 1 ? "Kabul Edildi" : d === 2 ? "Reddedildi" : "Bekliyor";
    const durumColor = d => d === 1 ? "success" : d === 2 ? "danger" : "warning";

    // Admin Teklif Onay/Red İşlemi
    const handleOfferStatusUpdate = async (offerId, newDurum) => {
        const label = durumText(newDurum);
        if (!window.confirm(`Bu teklifi "${label}" olarak işaretlemek istediğinize emin misiniz?`)) return;

        try {
            const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILAN_TEKLIFLERI(${offerId})`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ DURUM: newDurum })
            });

            if (response.ok) {
                setSelectedAdvertForOffers(prev => ({
                    ...prev,
                    allOffers: prev.allOffers.map(o => o.ID === offerId ? { ...o, DURUM: newDurum } : o)
                }));

                setTripsData(prevTrips => prevTrips.map(trip => {
                    if (trip.id === selectedAdvertForOffers.id) {
                        return {
                            ...trip,
                            allOffers: trip.allOffers.map(o => o.ID === offerId ? { ...o, DURUM: newDurum } : o)
                        };
                    }
                    return trip;
                }));
            } else {
                alert("Teklif durumu güncellenirken bir hata oluştu.");
            }
        } catch (error) {
            console.error("Güncelleme hatası:", error);
            alert("Bağlantı hatası!");
        }
    };

    const tripsColumns = useMemo(
        () => [
            {
                header: 'Kimlik / Tip',
                accessorKey: "id",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div>
                            <span className="text-body fw-bold">#{row.id}</span><br />
                            <Badge className="bg-info mb-1">{row.advertTypeTitle}</Badge><br />
                            <Badge className={row.direction.includes("Git") ? "bg-primary" : "bg-secondary"}>
                                {row.direction}
                            </Badge>
                        </div>
                    );
                }
            },
            {
                header: 'Güzergah',
                accessorKey: "startCity",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{ fontSize: '12px' }}>
                            <span className="text-success fw-bold">{row.startCity}</span> <br/>
                            <i className="mdi mdi-arrow-down text-muted"></i> <br/>
                            <span className="text-danger fw-bold">{row.endCity}</span>
                        </div>
                    );
                }
            },
            {
                header: 'Zaman Planı',
                accessorKey: "startDate",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                            <div><strong className="text-success">Bşl:</strong> {row.startDate}</div>
                            <div><strong className="text-danger">Bit:</strong> {row.endDate}</div>
                            {row.deadline !== "-" && <div><strong className="text-muted">Son:</strong> {row.deadline}</div>}
                        </div>
                    );
                }
            },
            {
                header: 'Müşteri / Araç',
                accessorKey: "customer",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    const tooltipId = `carTooltip-${row.id}`;
                    return (
                        <div style={{ maxWidth: "150px" }}>
                            <div className="text-truncate mb-1" title={row.customer}>{row.customer}</div>
                            <div id={tooltipId} style={{ cursor: "pointer", textDecoration: "underline dashed", fontSize: '12px' }}>
                                {row.brand} {row.model}
                            </div>
                            <UncontrolledTooltip target={tooltipId} placement="top">
                                Kasa: {row.carBody} | Motor: {row.engine}
                            </UncontrolledTooltip>
                        </div>
                    );
                }
            },
            {
                header: 'Mesafe / Süre / Yakıt',
                accessorKey: "distance",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div style={{ fontSize: '12px' }}>
                            <div><i className="mdi mdi-road-variant me-1"></i> {row.distance}</div>
                            <div><i className="mdi mdi-clock-outline me-1"></i> {row.duration}</div>
                            <div><i className="mdi mdi-gas-station me-1"></i> {row.fuelStatus}</div>
                        </div>
                    );
                }
            },
            {
                header: 'Finans',
                accessorKey: "price",
                cell: (cellProps) => {
                    const row = cellProps.row.original;
                    return (
                        <div>
                            <div className="fw-bold mb-1">{row.price} TL</div>
                            {row.invoiceId ? (
                                <Badge color={row.invoiceStatus === 'Ödendi' ? 'success' : 'warning'}>
                                    Fatura: {row.invoiceNo || "Kesildi"}
                                </Badge>
                            ) : (
                                <Badge color="light" className="text-muted border">Fatura Yok</Badge>
                            )}
                        </div>
                    );
                }
            },
            {
                header: 'Sistem Durumu',
                accessorKey: "isAdminCheck",
                cell: (cellProps) => {
                    const isChecked = cellProps.row.original.isAdminCheck;
                    return isChecked 
                        ? <Badge color="success">Aktif (Onaylı)</Badge>
                        : <Badge color="danger">Pasif (Bekliyor)</Badge>;
                }
            },
        {
        header: 'Eylemler',
        enableSorting: false,
        cell: (cellProps) => {
            const row = cellProps.row.original;
            
            
            const toggleAdminCheck = async () => {
                const newStatus = !row.isAdminCheck; // Mevcut durumun tersini alıyoruz
                
                // Kullanıcıdan onay isteyelim ki yanlışlıkla tıklanmasın
                if (!window.confirm(`Bu ilanı ${newStatus ? 'AKTİF (Onaylı)' : 'PASİF (Onay Bekliyor)'} duruma getirmek istediğinize emin misiniz?`)) {
                    return;
                }

                try {
                    const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILANLAR(${row.id})`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            AKTIF_DURUM: newStatus ? 'aktif' : 'pasif'
                        })
                    });

                    if (response.ok) {
                        // İşlem başarılıysa sayfayı yenilemeye gerek kalmadan local state'i (tabloyu) anında güncelliyoruz
                        setTripsData(prevData => 
                            prevData.map(item => 
                                item.id === row.id ? { ...item, isAdminCheck: newStatus } : item
                            )
                        );
                    } else {
                        alert("İlan durumu güncellenirken sunucu tarafında bir hata oluştu.");
                    }
                } catch (error) {
                    console.error("Durum güncelleme hatası:", error);
                    alert("İnternet bağlantınızı kontrol edin veya daha sonra tekrar deneyin.");
                }
            };

            return (
                <div className="d-flex flex-column gap-1">
                    <Link to={`/job-details/${row.id}`} className="btn btn-light btn-sm border-secondary text-dark">
                        Detaylar
                    </Link>
                    
                    {/* SADECE SÜRÜCÜ: Teklif Ver butonu */}
                    {/* SADECE SÜRÜCÜ: Teklif Durumu veya Teklif Ver butonu */}
                    {isDriver && (
                        row.hasOffer ? (
                            <div className="border border-info rounded p-1 text-center bg-soft-info mt-1">
                                <span className="d-block text-info fw-bold" style={{fontSize: "11px"}}>
                                    <i className="mdi mdi-check-all"></i> Teklifiniz: {row.myOfferPrice} ₺
                                </span>
                                <Badge color={
                                    row.myOfferStatus?.includes('Kabul') ? "success" : 
                                    row.myOfferStatus?.includes('Red') ? "danger" : "warning"
                                } style={{fontSize: "10px", marginTop: "2px"}}>
                                    {row.myOfferStatus || "Bekliyor"}
                                </Badge>
                            </div>
                        ) : (
                            <Link to={`/job-details/${row.id}`} className="btn btn-warning btn-sm mt-1">
                                Teklif Ver
                            </Link>
                        )
                    )}

                    {/* SADECE ADMİN: Onay/Pasif butonları ve Teklif Modalı */}
                {isAdmin && (
                    <>
                        <Button 
                            color="info" 
                            size="sm" 
                            onClick={() => {
                                setSelectedAdvertForOffers(row);
                                setIsOffersModalOpen(true);
                            }}
                        >
                            <i className="mdi mdi-format-list-bulleted me-1"></i> Gelen Teklifler ({row.allOffers?.length || 0})
                        </Button>
                        <Button color={row.isAdminCheck ? "danger" : "success"} size="sm" outline onClick={toggleAdminCheck}>
                            {row.isAdminCheck ? "Pasife Al" : "Aktif Et"}
                        </Button>
                    </>
                )}
                    
                    {row.invoiceId && (
                        <Link to={`/invoice-view/${row.invoiceId}`} className="btn btn-info btn-sm">
                            Faturayı Gör
                        </Link>
                    )}
                </div>
            );
        }
    }
        ],
        []
    );

        // --- ALINTILARIM TABLOSU KOLONLARI ---
    const quotesColumns = useMemo(() => {
        // Önce herkes için ortak olan ilk kolonu koyuyoruz
        let baseColumns = [
            { 
                header: 'Kimlik Alıntı', 
                accessorKey: "offerId", 
                enableSorting: true, 
                cell: (cellProps) => <span className="fw-bold">{cellProps.row.original.offerId}</span> 
            }
        ];

        // EĞER ADMİN İSE: "Sürücü" kolonunu 2. sıraya (index 1) yerleştiriyoruz
        if (isAdmin) {
            baseColumns.push({
                header: 'Sürücü',
                accessorKey: "driverName",
                cell: (cellProps) => <span className="text-primary fw-medium">{cellProps.row.original.driverName}</span>
            });
        }

        // Geri kalan ortak kolonları sona ekliyoruz
        baseColumns = [
            ...baseColumns,
            { header: 'Kimlik Yolculuk', accessorKey: "advertId", enableSorting: true },
            { header: 'Tarih', accessorKey: "date", enableSorting: true },
            { header: 'Teklif', accessorKey: "price", enableSorting: true, cell: (cellProps) => <span>{cellProps.row.original.price} €</span> },
            {
                header: 'Durum',
                accessorKey: "status",
                cell: (cellProps) => {
                    const status = cellProps.row.original.status.toLowerCase();
                    let color = status.includes("kabul") ? "success" : status.includes("red") ? "danger" : "warning";
                    return <Badge color={color}>{cellProps.row.original.status}</Badge>;
                }
            },
            {
                header: 'Eylemler',
                cell: (cellProps) => (
                    <Link to={`/job-details/${cellProps.row.original.advertId}`} className="btn btn-light btn-sm border">
                        Göreve Git
                    </Link>
                )
            }
        ];

        return baseColumns;
    }, [isAdmin]); // isAdmin değiştiğinde tablo yapısı güncellenir


        return (
            <React.Fragment>
                <div className="page-content">
                    <div className="container-fluid">
                        <Row className="mb-3">
        <Col>
            <h2 className="mb-3">Uygun geziler</h2>
            <div className="alert alert-warning" role="alert">
                <span className="badge bg-warning me-2">Yeni</span> 
                Bazı görevler yeni bir özellik içerir: tekliflerin anında doğrulanması <Link to="#" className="alert-link text-warning text-decoration-underline">Daha Fazlasını Oku</Link>
            </div>
        </Col>
        <Col className="text-end" md={4}>
            <Button outline color="primary" size="sm" className="me-2">
                <i className="mdi mdi-help-circle-outline me-1"></i> Bir görev nasıl aranır?
            </Button>
            
            {/* SADECE MÜŞTERİ: Yeni Görev Butonu */}
            {isCustomer && (
                <Link to="/create-mission" className="btn btn-primary btn-sm shadow-sm">
                    <i className="mdi mdi-plus me-1"></i> Yeni Görev Talebi Oluştur
                </Link>
            )}
        </Col>
    </Row>

                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="pt-0 pb-0 border-bottom">
                                        <Nav tabs className="nav-tabs-custom nav-justified">
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                                                    Yakındaki geziler
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                                                    Tüm yolculuklar
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")} style={{ cursor: 'pointer' }}>
                                                    Daha fazla seyahate erişin
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{ cursor: 'pointer' }}>
                                                    Alıntılarım
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")} style={{ cursor: 'pointer' }}>
                                                    Yardım
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </CardBody>
                                </Card>

                                <TabContent activeTab={activeTab} className="p-3 bg-white mt-2">
                                    
                                    {/* SEKME 1: Yakındaki Geziler */}
                                    <TabPane tabId="1">

                                        {isAdmin && (
                                            <div className="mb-4">
                                                <Nav pills>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'all' ? 'active cursor-pointer' : 'cursor-pointer border me-2'} 
                                                            onClick={() => setStatusFilter('all')}
                                                        >
                                                            Tümü
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'approved' ? 'active bg-success cursor-pointer' : 'cursor-pointer border me-2 text-dark'} 
                                                            onClick={() => setStatusFilter('approved')}
                                                        >
                                                            Onaylı İlanlar
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink 
                                                            className={statusFilter === 'pending' ? 'active bg-warning text-dark cursor-pointer' : 'cursor-pointer border text-dark'} 
                                                            onClick={() => setStatusFilter('pending')}
                                                        >
                                                            Onay Bekleyenler
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="text-muted">Size en yakın rotaların listesi Arama</div>
                                            <div>
                                                <Input type="text" placeholder="Anahtar kelime" style={{width: '250px', display: 'inline-block'}} className="form-control form-control-sm" />
                                                <Button color="light" size="sm" className="ms-1"><i className="mdi mdi-refresh"></i></Button>
                                            </div>
                                        </div>
                                        
                                        {isLoadingTrips ? (
                                            <div className="text-center py-5">
                                                <Spinner color="primary" /> <p className="mt-2">İlanlar yükleniyor...</p>
                                            </div>
                                        ) : (
                                        <TableContainer
        columns={tripsColumns}
        data={filteredTripsData} // tripsData YERİNE BURAYI DEĞİŞTİRDİK
        isCustomPageSize={true}
        isPagination={true}
        tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
    />
                                        )}
                                    </TabPane>

                                    {/* SEKME 2: Tüm Yolculuklar */}
                                    <TabPane tabId="2">
                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <label className="form-label text-muted">Kalkışta filtre</label>
                                                <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                                <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                            </Col>
                                            <Col md={3}>
                                                <label className="form-label text-muted">Varışta filtre</label>
                                                <Input type="select" className="form-select form-select-sm mb-1"><option>Bölüm numarası...</option></Input>
                                                <Input type="select" className="form-select form-select-sm"><option>Tüm bölgeler</option></Input>
                                            </Col>
                                        </Row>
                                        <TableContainer
                                            columns={tripsColumns}
                                            data={tripsData}
                                            isCustomPageSize={true}
                                            isPagination={true}
                                            tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                        />
                                    </TabPane>

                                    {/* SEKME 3: QR Kod */}
                                    <TabPane tabId="3">
                                        <div className="text-center bg-dark text-white rounded p-5 opacity-75 position-relative">
                                            <div className="position-absolute top-0 start-0 w-100 bg-success p-2 rounded-top">
                                                Mobil uygulamamıza erişin
                                            </div>
                                            <i className="mdi mdi-lock display-4 mt-4"></i>
                                            <h4 className="text-white mt-3">Daha fazla seyahate erişin</h4>
                                            <p>Sertifika gerektirenler de dahil olmak üzere tüm rotalarımıza erişmek için lütfen mobil uygulamaya bakın.</p>
                                            <div className="bg-white d-inline-block p-2 rounded mt-3">
                                                <i className="mdi mdi-qrcode-scan display-1 text-dark"></i>
                                            </div>
                                            <div className="mt-2">⬆️ Bu QR Kodunu tara 📸</div>
                                        </div>
                                    </TabPane>

                                    {/* SEKME 4: Alıntılarım (Kullanıcının Teklifleri) */}
                                    <TabPane tabId="4">
                                        <p className="text-muted">Bu arama kriterleri için {quotesData.length} teklifiniz var.</p>
                                        
                                        {isLoadingQuotes ? (
                                            <div className="text-center py-5">
                                                <Spinner color="primary" /> <p className="mt-2">Teklifleriniz yükleniyor...</p>
                                            </div>
                                        ) : quotesData.length > 0 ? (
                                            <TableContainer
                                                columns={quotesColumns}
                                                data={quotesData}
                                                isCustomPageSize={true}
                                                isPagination={true}
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                                            />
                                        ) : (
                                            <div className="text-center text-muted py-5">
                                                Henüz bir teklifiniz bulunmuyor.
                                            </div>
                                        )}
                                    </TabPane>

                                    {/* SEKME 5: Yardım */}
                                    <TabPane tabId="5">
                                        <h4>Sekme "Yakınlarda protracts"</h4>
                                        <p>Bu sekmede, kalkış veya varış adresinin evinize yakınlığına göre size sunabileceğimiz tüm rotaları bulacaksınız...</p>
                                        <h4 className="mt-4">"Benim tırnaklarım" (Alıntılarım) sekmesi</h4>
                                        <ul>
                                            <li><span className="text-warning">● Bekliyor:</span> teklif henüz ekiplerimiz tarafından incelenmedi.</li>
                                            <li><span className="text-success">● Kabul edildi:</span> görev size atandı.</li>
                                            <li><span className="text-danger">● Reddedildi:</span> görev size atanmadı.</li>
                                        </ul>
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </div>
                </div>


                {/* GELEN TEKLİFLER MODALI */}
            <Modal isOpen={isOffersModalOpen} toggle={toggleOffersModal} size="lg" centered scrollable>
                <ModalHeader toggle={toggleOffersModal} className="bg-light">
                    İlan #{selectedAdvertForOffers?.id} - Gelen Teklifler
                </ModalHeader>
                <ModalBody>
                    {selectedAdvertForOffers?.allOffers && selectedAdvertForOffers.allOffers.length > 0 ? (
                        <div className="table-responsive">
                            <Table className="table-sm table-nowrap align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Teklif No</th>
                                       <th>Sürücü Bilgisi</th>
                                        <th>Fiyat</th>
                                        <th>Tarih</th>
                                        <th>Durum</th>
                                        <th className="text-end">İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedAdvertForOffers.allOffers.map((offer, index) => (
                                        <tr key={index}>
                                            <td>#{offer.ID}</td>
                                            <td>
                                                <span className="fw-medium text-dark d-block">
                                                    {offer.KULLANICILAR ? offer.KULLANICILAR.AD_SOYAD : "Bilinmiyor"}
                                                </span>
                                                <span className="text-muted" style={{fontSize: "11px"}}>
                                                    ID: #{offer.KULLANICI_ID}
                                                </span>
                                            </td>
                                            <td className="fw-bold text-primary">{offer.TEKLIF_TUTARI} ₺</td>
                                            <td>{offer.TEKLIF_TARIHI ? new Date(offer.TEKLIF_TARIHI).toLocaleString('tr-TR') : "-"}</td>
                                            <td>
                                                <Badge color={durumColor(offer.DURUM)}>{durumText(offer.DURUM)}</Badge>
                                            </td>
                                            <td className="text-end">
                                                <div className="d-flex justify-content-end gap-1">
                                                    <Button color="success" size="sm" disabled={offer.DURUM === 1} onClick={() => handleOfferStatusUpdate(offer.ID, 1)}>
                                                        Kabul Et
                                                    </Button>
                                                    <Button color="danger" size="sm" outline disabled={offer.DURUM === 2} onClick={() => handleOfferStatusUpdate(offer.ID, 2)}>
                                                        Reddet
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">
                            <i className="mdi mdi-inbox-outline display-4 mb-2"></i>
                            <p>Bu ilan için henüz hiç teklif verilmemiş.</p>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            </React.Fragment>
        );
    }

    export default UygunGeziler;